import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { ServiceCode } from '@shared/ui-service';

@Component({
  selector: 'csl-service-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './service-image.component.html',
  styleUrl: './service-image.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col w-full rounded-4xl md:flex-row-reverse md:items-stretch',
    'data-testid': 'service-card-root',
  },
})
export class ServiceImageComponent {
  serviceCode$$ = input.required<ServiceCode>();
  isCollapsed$$ = input(false);
  isReverse$$ = input(false);

  @HostBinding('class.flex-col-reverse') get isReverse() {
    return this.isReverse$$();
  }

  @HostBinding('class.flex-col') get isAhead() {
    return !this.isReverse$$();
  }
}
